/**
 * @packageDocumentation
 * @module appStructureEnums
 *
 * @remarks
 * This file is used to manage the applications structure and features.
 * We manage the sidebar apps, app features, page tabs, and other nested features here.
 */

/**
 * Top Level Sidebar Apps
 */
export enum EvidencePlatformSidebarAppID {
  projects = 'projects',
  organizations = 'organizations',
  users = 'users',
  extractionAccuracy = 'extraction-accuracy',
  dataReliability = 'data-reliability',
  conceptGroups = 'concept-groups',
  conceptMapping = 'concept-mapping',
  analyticalVariables = 'analytical-variables',
  // TODO: cleanup with research_assistant_developer_tools ff — OR-6432 Block B.
  // Internal-only page for reviewing RA sessions across projects/orgs; never
  // shown to customers. See docs/research-assistant/OR-6432-session-observability-spike.md.
  raSessionReview = 'ra-session-review',
}

/**
 * Project Sidebar App Features
 */
export enum ProjectsSidebarAppFeatureId {
  cohorts = 'cohorts',
  dataReliability = 'data-reliability',
}

export enum CohortsFeaturePage {
  cohortBuilder = 'cohort-builder',
}

export enum CohortBuilderPageTab {
  // Cohort definition tabs
  results = 'results',
  definition = 'definition',
  sql = 'sql',
  history = 'history',

  // Foundational components tabs
  events = 'events',
  concepts = 'concepts',
  datasets = 'datasets',
}

export enum SubjectsDrillDown {
  subjectsDetail = 'subjects-detail',
}

export enum DataReliabilityPageTab {
  accuracy = 'accuracy',
  completeness = 'completeness',
  traceability = 'traceability',
}

/**
 * Organizations Sidebar App Features
 */
export enum OrganizationsSidebarAppFeatureId {
  organizations = 'organizations',
}

/**
 * Organizations Page Tabs
 */
export enum OrganizationsPageTab {
  customers = 'customers',
  researchPartners = 'research-partners',
  verantos = 'verantos',
}

/**
 * User Sidebar App Features
 */
export enum UserSidebarAppFeatureId {}
